import React, { useEffect, useRef, useCallback, useState } from 'react';
import './App.css';
import { EventTypePicker } from "./components/EventTypePicker";
import { Room } from "./components/Room";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {

  return <>

    <Router>
    <Switch>
          <Route path="/room/:eventTypeId/:roomName">
            {<Room />}
          </Route>
          <Route path="/">
            {<EventTypePicker />}
          </Route>
        </Switch>

    </Router>
  </>;
}

export default App;
